export default __webpack_public_path__ + "static/media/est-diamante.bbff4bc9.png";